import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../pages/login/Login';
import LoginLayout from '../layouts/loginLayout/LoginLayout';
import Signup from '../pages/signup/Signup';
import NotFound from '../pages/notFound/NotFound';
import PrivateRoute from './PrivateRoute';
import AuthRoute from './AuthRoute';
import ForgotPassword from '../pages/forgotPassword/ForgotPassword';
import ResetPassword from '../pages/resetPassword/ResetPassword';
import MainLayout from '../layouts/mainLayout/MainLayout';
import Profile from '../pages/profile/Profile';
import ChangePassword from '../pages/changePassword/ChangePassword';
import RoleBasedRoute from './RoleBasedRoute';
/* Instructor Routes */
import InstructorHome from '../pages/instructor/home/Home';
import InstructorEvaluations from '../pages/instructor/evaluations/Evaluations';
import Evaluation from '../pages/instructor/evaluation/Evaluation';
import InstructorEvaluationSummary from '../pages/instructor/evaluationSummary/EvaluationSummary';
import StudentOverview from '../pages/instructor/studentOverview/StudentOverview';
import InstructorStudents from '../pages/instructor/students/Students';
import InstructorSchedule from '../pages/instructor/schedule/Schedule';
import InstructorAvailability from '../pages/instructor/availability/Availability';
import InstructorReports from '../pages/instructor/reports/Reports';
/* Student Routes */
import StudentHome from '../pages/student/home/Home';
import StudentEvaluations from '../pages/student/evaluations/Evaluations';
import StudentEvaluationSummary from '../pages/student/evaluationSummary/EvaluationSummary';
import CaseLog from '../pages/student/caseLog/CaseLog';
import StudentLogReports from '../pages/student/logReports/LogReports';
import CaseLogCalendar from '../pages/student/caseLogCalendar/CaseLogCalendar';
import CaseLogList from '../pages/student/caseLogList/CaseLogList';
import ReadingDayLog from '../pages/student/readingDayLog/ReadingDayLog';
import Schedule from '../pages/student/schedule/Schedule';
import StudentReports from '../pages/student/reports/StudentReports';
import StudentSurveys from '../pages/student/surveys/Surveys';
import SurveyRequest from '../pages/student/surveyRequest/SurveyRequest';
/* Program Director */
import ProgramDirectorHome from '../pages/programDirector/home/Home';
import ProgramCoordinatorHome from '../pages/programCoordinator/home/Home';
import ApplicationAdminHome from '../pages/applicationAdmin/home/Home';
import ProgramDirectorStudents from '../pages/programDirector/students/Students';
import ExportLogReports from '../pages/programDirector/exportLogReports/ExportLogReports';
import LogReportStudents from '../pages/programDirector/logReportStudents/LogReportStudents';
import ProgramDirectorLogReports from '../pages/programDirector/logReports/LogReports';
import Reports from '../pages/programDirector/reports/Reports';
import Instructors from '../pages/programDirector/instructors/Instructors';
import CreateInstructor from '../pages/programDirector/createInstructor/CreateInstructor';
import ProgramDirectorEvaluations from '../pages/programDirector/evaluations/Evaluations';
import ProgramDirectorEvaluationSummary from '../pages/programDirector/evaluationSummary/EvaluationSummary';
import CreateStudent from '../pages/programDirector/createStudent/CreateStudent';
import StudentGraduationSummary from '../pages/programDirector/studentGraduationSummary/StudentGraduationSummary';
import Programs from '../pages/programDirector/programs/Programs';
import CreateProgram from '../pages/programDirector/createProgram/CreateProgram';

import StudentEvaluationDetail from '../pages/programDirector/studentEvaluationDetail/StudentEvaluationDetail';
import ClinicalSite from '../pages/programDirector/clinicalSite/ClinicalSite';
import ProgramDirectorSchedule from '../pages/programDirector/schedule/Schedule';
import StudentRanking from '../pages/programDirector/studentRanking/StudentRanking';
import StudentGraduation from '../pages/programDirector/studentGraduation/StudentGraduation';
import EmployerDetails from '../pages/programDirector/employerDetails/EmployerDetails';
import EmployerDetailsForm from '../pages/employerDetailsForm/EmployerDetailsForm';
import EditHistory from '../pages/programDirector/editHistory/EditHistory';
import CreateClinicalSite from '../pages/programDirector/createClinicalSite/CreateClinicalSite';
import HealthSystems from '../pages/programDirector/healthSystems/HealthSystems';
import CreateHealthSystem from '../pages/programDirector/createHealthSystem/CreateHealthSystem';
import CaseLogSettings from '../pages/programDirector/caseLogSettings/CaseLogSettings';
import ClinicalCoordinators from '../pages/programDirector/clinicalCoordinators/ClinicalCoordinators';
import CreateClinicalCoordinator from '../pages/programDirector/createClinicalCoordinator/CreateClinicalCoordinator';
import ProgramCoordinators from '../pages/programDirector/programCoordinators/ProgramCoordinators';
import CreateProgramCoordinator from '../pages/programDirector/createProgramCoordinator/CreateProgramCoordinator';
import ProgramCoordinatorPermissions from '../pages/programDirector/programCoordinatorPermissions/ProgramCoordinatorPermissions';
import EvaluationQuestions from '../pages/programDirector/evaluationQuestions/EvaluationQuestions';
import EvaluationOptions from '../pages/programDirector/evaluationOptions/EvaluationOptions';
import CreateEvaluationOption from '../pages/programDirector/createEvaluationOption/CreateEvaluationOption';
import CreateEvaluationQuestion from '../pages/programDirector/createEvaluationQuestion/CreateEvaluationQuestion';
import Surveys from '../pages/programDirector/surveys/Surveys';
import CreateSurvey from '../pages/programDirector/createSurvey/CreateSurvey';
import SurveySubmissions from '../pages/programDirector/surveySubmissions/SurveySubmissions';
import Subscriptions from '../pages/applicationAdmin/subscriptions/Subscriptions';
import CreateSubscription from '../pages/applicationAdmin/createSubscription/CreateSubscription';
import ProgramDirectors from '../pages/applicationAdmin/programDirectors/ProgramDirectors';
import CreateProgramDirector from '../pages/applicationAdmin/createProgramDirector/CreateProgramDirector';

const AppRoutes = () => {  
  return (
    <Routes>
      <Route element={<LoginLayout />}>
        <Route path="*" element={<NotFound />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/signup/:signupToken" element={<Signup />} />
        <Route path="/reset-password/:resetToken" element={<ResetPassword />} />
        <Route path="/employer-details/:updateToken" element={<EmployerDetailsForm />} />
        <Route element={<AuthRoute />}>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Route>
      </Route>
      <Route element={<MainLayout />}>
        <Route element={<PrivateRoute />}>
          <Route path="/profile" element={<Profile />} />
          <Route path='/change-password' element={<ChangePassword />} /> 
          <Route path="/" element={<RoleBasedRoute elements={{
            'Instructor': <InstructorHome />,
            'Student': <StudentHome />,
            'Program Director': <ProgramDirectorHome />,
            'Program Coordinator': <ProgramCoordinatorHome />,
            'Application Admin': <ApplicationAdminHome />
          }} fallback='/' />} />
          <Route path="/evaluations" element={<RoleBasedRoute elements={{
            'Instructor': <InstructorEvaluations />,
            'Student': <StudentEvaluations />,
            'Program Director': <ProgramDirectorEvaluations />,
            'Program Coordinator': <ProgramDirectorEvaluations />
          }} permissions={{ 'Program Coordinator': 'canConfirmEvaluations' }} />} />
          <Route path="/student-overview/:studentId" element={<RoleBasedRoute elements={{
            'Instructor': <StudentOverview />
          }} />} />
          <Route path="/student-overview/evaluation/:evaluationId" element={<RoleBasedRoute elements={{
            'Instructor': <Evaluation />
          }} />} />
          <Route path="/student-overview/evaluation/:evaluationId/summary" element={<RoleBasedRoute elements={{
            'Instructor': <InstructorEvaluationSummary />
          }} />} />
          <Route path="/students" element={<RoleBasedRoute elements={{
            'Instructor': <InstructorStudents />,
            'Program Director': <ProgramDirectorStudents />,
            'Program Coordinator': <ProgramDirectorStudents />
          }} />} />
          <Route path="/evaluations/:evaluationId" element={<RoleBasedRoute elements={{
            'Student': <Evaluation />
          }} />} />
          <Route path="/evaluations/:evaluationId/summary" element={<RoleBasedRoute elements={{
            'Student': <StudentEvaluationSummary />,
            'Program Director': <ProgramDirectorEvaluationSummary />,
            'Program Coordinator': <ProgramDirectorEvaluationSummary />
          }} permissions={{ 'Program Coordinator': 'canConfirmEvaluations' }} />} />
          <Route path="/log-reports" element={<RoleBasedRoute elements={{
            'Student': <StudentLogReports />,
            'Program Director': <LogReportStudents />,
          }} />} />
          <Route path="/log-reports/calendar" element={<RoleBasedRoute elements={{
            'Student': <CaseLogCalendar />,
          }} />} />
          <Route path="/log-reports/:logReportId/case-logs" element={<RoleBasedRoute elements={{
            'Student': <CaseLogList />
          }} />} />
          <Route path="/log-reports/:logReportId/case-logs/:caseLogId" element={<RoleBasedRoute elements={{
            'Student': <CaseLog />
          }} />} />
          <Route path="/log-reports/:logReportId/reading-day" element={<RoleBasedRoute elements={{
            'Student': <ReadingDayLog />
          }} />} />
          <Route path="/log-reports/export" element={<RoleBasedRoute elements={{
            'Program Director': <ExportLogReports />
          }} />} />
          <Route path="/log-reports/student/:studentId" element={<RoleBasedRoute elements={{
            'Program Director': <ProgramDirectorLogReports />
          }} />} />
          <Route path="/log-reports/student/:studentId/log-reports/:logReportId/case-logs" element={<RoleBasedRoute elements={{
            'Program Director': <CaseLogList />
          }} />} />
          <Route path="/log-reports/student/:studentId/log-reports/:logReportId/case-logs/:caseLogId" element={<RoleBasedRoute elements={{
            'Program Director': <CaseLog />
          }} />} />
          <Route path="/log-reports/student/:studentId/log-reports/:logReportId/reading-day" element={<RoleBasedRoute elements={{
            'Program Director': <ReadingDayLog />
          }} />} />
          <Route path="/schedules" element={<RoleBasedRoute elements={{
            'Student': <Schedule />,
            'Instructor': <InstructorSchedule />
          }} />} />
          <Route path="/availability" element={<RoleBasedRoute elements={{
            'Instructor': <InstructorAvailability />
          }} />} />
          <Route path="/reports" element={<RoleBasedRoute elements={{
            'Student': <StudentReports />,
            'Instructor': <InstructorReports />,
            'Program Director': <Reports />
          }} />} />
          <Route path="/instructors" element={<RoleBasedRoute elements={{
            'Program Director': <Instructors />
          }} />} />
          <Route path="/instructors/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateInstructor />
          }} />} />
          <Route path="/instructors/edit/:instructorId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateInstructor />
          }} />} />
          <Route path="/instructors/availability" element={<RoleBasedRoute elements={{
            'Program Director': <InstructorAvailability />
          }} />} />
           <Route path="/students/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateStudent />
          }} />} />
          <Route path="/students/edit/:studentId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateStudent />,
            'Program Coordinator': <CreateStudent />
          }} />} />
          <Route path="/students/summary/:studentId" element={<RoleBasedRoute elements={{
            'Program Director': <StudentGraduationSummary />,
            'Program Coordinator': <StudentGraduationSummary />
          }} />} />
          <Route path="/evaluations/student/:studentId" element={<RoleBasedRoute elements={{
            'Program Director': <StudentEvaluationDetail />,
            'Program Coordinator': <StudentEvaluationDetail />
          }} />} />
          <Route path="/clinical-site" element={<RoleBasedRoute elements={{
            'Program Director': <ClinicalSite />
          }} />} />
          <Route path="/evaluation-questions" element={<RoleBasedRoute elements={{
            'Program Director': <EvaluationQuestions />
          }} />} />
          <Route path="/evaluation-questions/edit/:questionId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateEvaluationQuestion />
          }} />} />
          <Route path="/evaluation-options" element={<RoleBasedRoute elements={{
            'Program Director': <EvaluationOptions />
          }} />} />
          <Route path="/evaluation-options/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateEvaluationOption />
          }} />} />
          <Route path="/evaluation-options/edit/:optionId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateEvaluationOption />
          }} />} />
          <Route path="/clinical-sites/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateClinicalSite />
          }} />} />
          <Route path="/clinical-sites/edit/:siteId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateClinicalSite />
          }} />} />
          <Route path="/health-systems" element={<RoleBasedRoute elements={{
            'Program Director': <HealthSystems />
          }} />} />
          <Route path="/health-systems/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateHealthSystem />
          }} />} />
          <Route path="/health-systems/edit/:systemId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateHealthSystem />
          }} />} />
          <Route path="/programs" element={<RoleBasedRoute elements={{
            'Program Director': <Programs />,
            'Program Coordinator': <Programs />
          }} />} />
          <Route path="/programs/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateProgram />,
            'Program Coordinator': <CreateProgram />
          }} />} />
          <Route path="/programs/edit/:programId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateProgram />,
            'Program Coordinator': <CreateProgram />
          }} />} />
          <Route path="/schedule" element={<RoleBasedRoute elements={{
            'Program Director': <ProgramDirectorSchedule />,
            'Program Coordinator': <ProgramDirectorSchedule />
          }} />} />
          <Route path="/schedule/history" element={<RoleBasedRoute elements={{
            'Program Director': <EditHistory />
          }} />} />
          <Route path="/student-graduation" element={<RoleBasedRoute elements={{
            'Program Director': <StudentGraduation />
          }} />} />
          <Route path="/employer-details" element={<RoleBasedRoute elements={{
            'Program Director': <EmployerDetails />
          }} />} />
          <Route path="/student-ranking" element={<RoleBasedRoute elements={{
            'Program Director': <StudentRanking />
          }} />} />
          <Route path="/case-log-settings" element={<RoleBasedRoute elements={{
            'Program Director': <CaseLogSettings />
          }} />} />
          <Route path="/clinical-coordinators" element={<RoleBasedRoute elements={{
            'Program Director': <ClinicalCoordinators />
          }} />} />
          <Route path="/clinical-coordinators/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateClinicalCoordinator />
          }} />} />
          <Route path="/clinical-coordinators/edit/:coordinatorId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateClinicalCoordinator />
          }} />} />
          <Route path="/program-coordinators" element={<RoleBasedRoute elements={{
            'Program Director': <ProgramCoordinators />
          }} />} />
          <Route path="/program-coordinators/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateProgramCoordinator />
          }} />} />
          <Route path="/program-coordinators/edit/:coordinatorId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateProgramCoordinator />
          }} />} />
          <Route path="/program-coordinators/permissions/:coordinatorId" element={<RoleBasedRoute elements={{
            'Program Director': <ProgramCoordinatorPermissions />
          }} />} />
          <Route path="/surveys" element={<RoleBasedRoute elements={{
            'Program Director': <Surveys />,
            'Student': <StudentSurveys />
          }} />} />
          <Route path="/surveys/create" element={<RoleBasedRoute elements={{
            'Program Director': <CreateSurvey />
          }} />} />
          <Route path="/surveys/edit/:surveyId" element={<RoleBasedRoute elements={{
            'Program Director': <CreateSurvey />
          }} />} />
          <Route path="/surveys/submissions/:surveyId" element={<RoleBasedRoute elements={{
            'Program Director': <SurveySubmissions />
          }} />} />
          <Route path="/surveys/:requestId" element={<RoleBasedRoute elements={{
            'Student': <SurveyRequest />
          }} />} />
          <Route path="/subscriptions" element={<RoleBasedRoute elements={{
            'Application Admin': <Subscriptions />
          }} />} />
          <Route path="/subscriptions/create" element={<RoleBasedRoute elements={{
            'Application Admin': <CreateSubscription />
          }} />} />
          <Route path="/subscriptions/edit/:subscriptionId" element={<RoleBasedRoute elements={{
            'Application Admin': <CreateSubscription />
          }} />} />
          <Route path="/program-directors" element={<RoleBasedRoute elements={{
            'Application Admin': <ProgramDirectors />
          }} />} />
          <Route path="/program-directors/create" element={<RoleBasedRoute elements={{
            'Application Admin': <CreateProgramDirector />
          }} />} />
          <Route path="/program-directors/edit/:programDirectorId" element={<RoleBasedRoute elements={{
            'Application Admin': <CreateProgramDirector />
          }} />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRoutes;